export const NOTIFICATIONS_TABLE_SORT_ENABLED = 'NOTIFICATIONS_TABLE_SORT_ENABLED'
export const NOTIFICATIONS_TABLE_SORT_DISABLED = 'NOTIFICATIONS_TABLE_SORT_DISABLED'
export const NOTIFICATIONS_TABLE_SORT_UPDATED = 'updated'
export const NOTIFICATIONS_TABLE_SORT_STATE = 'state'
export const NOTIFICATIONS_TABLE_SORT_TYPE = 'message__message_type__name'
export const NOTIFICATIONS_TABLE_SORT_IMPORTANCE = 'message__message_importance__name'
// export const NOTIFICATIONS_TABLE_SORT_IMPORTANCE = 'message__message_type__name'
export const NOTIFICATIONS_TABLE_SORT_SUBJECT = 'message__subject'
export const NOTIFICATIONS_TABLE_SORT_BODY = 'message__body'
export const NOTIFICATIONS_TABLE_SORT_CREATED = 'created'
export const NOTIFICATIONS_TABLE_SORT_READ = 'date_read'

const enable = (sortField, order) => ({
  type: NOTIFICATIONS_TABLE_SORT_ENABLED,
  sortField,
  order,
})

const disable = () => ({
  type: NOTIFICATIONS_TABLE_SORT_DISABLED,
})

export const enableNotificationsSort = (sortField, order) => (dispatch) => dispatch(enable(sortField, order))

export const disableNotificationsSort = () => (dispatch) => dispatch(disable())
